export default __webpack_public_path__ + "static/media/lodging1.5957f7b1.jpg";